var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTngdliuthuthp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8226,
    cy: 40,
    r: 40,
    fill: "#6A01FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.5938,
    width: 43,
    height: 41.9961,
    rx: 5.40465,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8718,
    y: 21.8281,
    width: 5.51282,
    height: 35.5352,
    rx: 2.75641,
    fill: "#6A01FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6154,
    y: 36.9062,
    width: 5.51282,
    height: 20.4596,
    rx: 2.75641,
    fill: "#6A01FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7436,
    y: 30.4375,
    width: 5.51282,
    height: 26.9206,
    rx: 2.75641,
    fill: "#6A01FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTngdliuthuthp);
export default __webpack_public_path__ + "static/media/tổng dữ liệu thu thập.01ae636f35e672d05aad966e61e1a0cb.svg";
export { ForwardRef as ReactComponent };